import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-cle-labor-details-wrapper',
  templateUrl: './cle-labor-details-wrapper.component.html',
  styleUrls: ['./cle-labor-details-wrapper.component.scss'],
})
export class CleLaborDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
